import React, { useState } from 'react';
import { BreadCrumb } from '../../components';
import { getBreadCrumbList } from '../../utils/helper';
import styled from 'styled-components';
import { font } from '../../assets/common';
import FirstSectionPosition from './FirstSectionPosition';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';
import SecondSectionPosition from './SecondSectionPosition';

const Container = styled.section`
  font-family: ${font.inter};
  color: #3d3d3d;
`;

const Title = styled.div`
  font-family: ${font.inter};
  font-size: 24px;
  font-weight: 700;
  line-height: 29.05px;
  letter-spacing: 0.30000001192092896px;
  text-align: left;
  color: #3f3c4c;
  margin-top: 10px;
`;

const PrintProfile = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px 0px;
  span {
    font-weight: 500;
    color: #00a19c;
    padding: 5px 10px;
    background-color: #fbfdff;
    border: 1px solid #e9edf0;
    font-size: 12px;
    border-radius: 4px;
  }
`;

const PositionProfile = () => {
  const params = useParams();
  const { position_code } = params;
  const roleActive = useSelector((state) => state.user.roleActive);
  const [breadcrumb, setBreadCrumb] = useState([`Dashboard`]);

  return (
    <div>
      <BreadCrumb level={2} breadCrumbList={getBreadCrumbList(breadcrumb)} />
      <Title>Position Profile</Title>
      <Container>
        <PrintProfile>
          <span>Print Profile</span>
        </PrintProfile>
        <FirstSectionPosition roleActive={roleActive} position_code={position_code} setBreadCrumb={setBreadCrumb} />
        <SecondSectionPosition roleActive={roleActive} position_code={position_code} />
      </Container>
    </div>
  );
};

export default PositionProfile;
